import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, unwrap, type Schemas } from './client';

export type AppNotification = Schemas['NotificationDto'];

const key = ['notifications'] as const;

/** In-App-Benachrichtigungen (NOT-01); wird regelmäßig aktualisiert. */
export function useNotifications() {
  return useQuery({
    queryKey: key,
    queryFn: () => unwrap(api.GET('/api/v1/notifications', { params: { query: { limit: 30 } } })),
    refetchInterval: 60_000,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => unwrap(api.POST('/api/v1/notifications/{id}/read', { params: { path: { id } } })),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}

export function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => unwrap(api.POST('/api/v1/notifications/read-all')),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}
